// DO NOT EDIT -- generated from Go package fs/services/webber/internal/admin

///////////
// Enums //
///////////

export enum Auth0OrgAction {
	AddConnection = "addConnection",
	EnforceConnection = "enforceConnection",
	EnableAutoProvision = "enableAutoProvision",
	RemoveConnection = "removeConnection"
}


/////////////
// Structs //
/////////////

export interface Auth0UIConnection {
  ID: string;
  TeamName: string;
  Orgs: string[] | null;
}

export interface AddAuth0ClientRequest {
  ClientName: string;
  ClientId: string;
  ClientSecret: string;
}

export interface AddAuth0ConnectionRequest {
  TeamName: string;
  IdpMetadata: string;
}

// subset of model.Org that we need for auth work
// I find this type gross, but directly using a model.Org fails with the current tsexport setup.
export interface OrgAuthFields {
  IdProvider: string;
  IdProviderEnforced: boolean;
  IdProviderIntId: string;
  AutoProvisionEnabled: boolean;
}

export interface ListAuth0ConfigRsp {
  Connections: Array<Auth0UIConnection | null> | null;
  Orgs: {[key: string]: OrgAuthFields | null} | null;
}

export interface Auth0OrgConnectionRequest {
  OrgId: string;
  Action: Auth0OrgAction;
  ConnectionId?: string;
  Enforced?: boolean;
  AutoProvision?: boolean;
  TeamName?: string;
}
